import { faCaretLeft, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import "./ReceiveCash2Modal.css";
import ConfirmationModal from "../confirmationModal/ConfirmationModal";
import CashCollectedModal from "../cashcollectedModal/CashCollectedModal";
import avatarImg from "../../../assets/images/header_images/user.png";

const ReceiveCash2Modal = ({
  show = true,
  onHide,
  title = "Receive Cash",
  date = "12 Aug 2026",
  personName = "Ankit Patil",
  collectedCash = 3450,
  onReceiveCash,
}) => {
  
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showCashCollectedModal, setShowCashCollectedModal] = useState(false);

  const handleReceiveCash = () => {
    // Close Receive Cash modal
    onHide();

    // Open Confirmation modal
    setShowConfirmationModal(true);

    if (onReceiveCash) {
      onReceiveCash();
    }
  };

  const handleConfirmationClose = () => {
    setShowConfirmationModal(false);
  };

  const handleNoButtonClick = () => {
    setShowConfirmationModal(false);
  };

  const handleYesButtonClick = () => {
    // Close Confirmation Modal
    setShowConfirmationModal(false);

    // Open Cash Collected Modal
    setShowCashCollectedModal(true);

    console.log("Payment collected");
  };

  const handleCashCollectedClose = () => {
    setShowCashCollectedModal(false);
  };

  return (
    <>
      {/* Receive Cash Modal */}
      <Modal
        show={show}
        onHide={onHide}
        centered
        className="ReceiveCash2Modal common_modal"
      >
        {/* Header Section */}
        <Modal.Header closeButton>
          <div className="d-flex align-items-center gap-2">
            <button
              className="back-btn border-0"
              onClick={onHide}
              aria-label="Back"
              type="button"
            >
              <span className="back-arrow">
                <FontAwesomeIcon icon={faCaretLeft} />
              </span>
            </button>

            <Modal.Title className="modal-custom-title">{title}</Modal.Title>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="receive_cash_section">
            <div className="receive_cash_card">
              <div className="receive_cash_top">
                <span className="receive_cash_date">{date}</span>

                <span className="receive_cash_label">
                  (Todays Collected Cash)
                </span>
              </div>

              <div className="receive_cash_bottom">
                <div className="receive_cash_person">
                  <img
                    src={avatarImg}
                    alt={personName}
                    className="cash_person"
                  />
                  {/* <FontAwesomeIcon icon={faUser} /> */}

                  <span className="receive_cash_person_name">{personName}</span>
                </div>

                <span className="receive_cash_amount">₹ {collectedCash}</span>
              </div>
            </div>

            <div className="receive_cash_action">
              <button
                type="button"
                className="receive_cash_btn"
                onClick={handleReceiveCash}
              >
                Receive cash
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Confirmation Modal */}
      {/* <ConfirmationModal
        show={showConfirmationModal}
        onHide={handleConfirmationClose}
        title="Payment Confirmation"
        statusTitle="Have You Collected Payment?"
        message={
          <>
            Please confirm that the payment has been collected From the Sale
            person.
            <div className="hr_divider" />
          </>
        }
        noButtonText="No, Collect Payment"
        yesButtonText="Yes, Collected"
        onNoButtonClick={handleNoButtonClick}
        onYesButtonClick={handleYesButtonClick}
        className="PaymentConfirmationModal"
      /> */}

      {/* Cash Collected Successfully Modal */}
      {/* <CashCollectedModal
        show={showCashCollectedModal}
        onHide={handleCashCollectedClose}
      /> */}
    </>
  );
};

export default ReceiveCash2Modal;
